import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../../utils/api';
import {
  Calendar,
  Clock,
  UserCheck,
  ArrowLeft,
  ChefHat,
  Building2,
  Wifi,
  Database,
  Fingerprint
} from 'lucide-react';
import BiometricoSyncModal from './BiometricoSyncModal';
import './Header.css';

const Header = ({ titulo, color = '#2563eb', showSystemInfo = true, showBackButton = true, showBiometrico = true }) => {
  const navigate = useNavigate();
  const [fechaHora, setFechaHora] = useState(new Date());
  const [usuarioActual, setUsuarioActual] = useState(null);
  const [showBiometricoModal, setShowBiometricoModal] = useState(false);

  // Efecto para actualizar la fecha y hora cada segundo
  useEffect(() => {
    const interval = setInterval(() => {
      setFechaHora(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Efecto para obtener usuario actual
  useEffect(() => {
    const usuario = API.auth.getCurrentUser();
    setUsuarioActual(usuario);
  }, []);

  const handleBackToDashboard = useCallback(() => {
    navigate('/dashboard');
  }, [navigate]);

  // Formatear fecha y hora con estilo profesional
  const formatearFecha = useCallback((fecha) => {
    return fecha.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }, []);

  const formatearHora = useCallback((fecha) => {
    return fecha.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }, []);

  return (
    <header className="header-professional" style={{ '--header-color': color }}>
      <div className="header-container-professional">
        {/* Sección izquierda - Branding y título */}
        <div className="header-left-professional">
          <div className="brand-section-header">
            <div className="brand-icon-header">
              <ChefHat size={24} />
            </div>
            <div className="brand-info-header">
              <h1 className="system-title">{titulo}</h1>
              <span className="system-subtitle">Sistema de Gestión Restaurante</span>
            </div>
          </div>

          {showSystemInfo && (
            <div className="system-metrics">
              <div className="metric-item">
                <Database size={16} />
                <span>Conectado</span>
              </div>
              <div className="metric-item">
                <Wifi size={16} />
                <span>Online</span>
              </div>
            </div>
          )}
        </div>

        {/* Sección central - Fecha y hora */}
        <div className="header-center-professional">
          <div className="datetime-container">
            <div className="date-section">
              <Calendar size={18} />
              <span className="date-text">{formatearFecha(fechaHora)}</span>
            </div>
            <div className="time-section">
              <Clock size={18} />
              <span className="time-text">{formatearHora(fechaHora)}</span>
            </div>
          </div>
        </div>

        {/* Sección derecha - Usuario y acciones */}
        <div className="header-right-professional">
          {showBiometrico && (
            <button
              className="biometrico-button-header"
              onClick={() => setShowBiometricoModal(true)}
              title="Sincronización Biométrica"
            >
              <Fingerprint size={18} />
              <span>Biométrico</span>
            </button>
          )}

          {usuarioActual && (
            <div className="user-badge-professional">
              <UserCheck size={18} />
              <div className="user-info-text">
                <span className="user-name">{usuarioActual.nombre || usuarioActual.usuario}</span>
                <span className="user-role">Administrador</span>
              </div>
            </div>
          )}

          {showBackButton && (
            <button
              className="back-button-professional"
              onClick={handleBackToDashboard}
              title="Volver al Dashboard Principal"
            >
              <ArrowLeft size={18} />
              <span>Volver al Dashboard</span>
            </button>
          )}
        </div>
      </div>

      {/* Modal de Sincronización Biométrica */}
      <BiometricoSyncModal
        isOpen={showBiometricoModal}
        onClose={() => setShowBiometricoModal(false)}
      />
    </header>
  );
};

export default Header;